import React, { createContext, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useLazyGetUserInfoQuery } from "store/slices/apis/authSlice";
import { useLazyGetProjectPermissionQuery } from "store/slices/apis/projectPermissionSlice";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    // const { projectId } = useParams();
    const [authenticated, setAuthenticated] = useState(false);
    const [user, setUser] = useState(null); // user data from API
    const [triggerUserInfo, { data, isSuccess, isError, isLoading }] = useLazyGetUserInfoQuery();
    const [projectPermissionFun, projectPermissionRes] = useLazyGetProjectPermissionQuery();
    const [token, setToken] = useState(() => localStorage.getItem("token"));

    useEffect(() => {
        if (token) {
            triggerUserInfo();
        }
    }, [token]);

    // useEffect(() => {
    //     console.log(projectId);

    //     if (user?.permission?.length == 0 && projectId !== undefined) {
    //         projectPermissionFun({ projectId });
    //     }
    // }, [user, projectId]);

    useEffect(() => {
        if (isSuccess && data) {
            setUser(data);
            setAuthenticated(true)
        }
    }, [data, isSuccess, isError]);

    useEffect(() => {
        if (isSuccess && data) {
            setUser(data);
            setAuthenticated(true)
        }
    }, [data, isSuccess, isError]);

    const getuserInfo = (newToken) => {

        localStorage.setItem("token", newToken);
        triggerUserInfo();
    };

    const getProjectPermissionInfo = async (projectId) => {
        await projectPermissionFun({ projectId });
    };

    useEffect(() => {
        if (projectPermissionRes?.isSuccess) {
            if (projectPermissionRes?.data?.status == "success") {
                setUser({
                    ...data,
                    permission: projectPermissionRes?.data?.result?.modules
                });
            }
        }
    }, [projectPermissionRes]);

    return (
        <AuthContext.Provider value={{ user, getuserInfo, setUser, getProjectPermissionInfo, authenticated, setAuthenticated, isLoading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
